import React from 'react';
import * as styles from './grid.module.scss';
import TextBlock from '../TextBlock/TextBlock';

const SectionGrid = ({ data }) => {
 const { appearances } = data;
 //console.log(appearances, 'appearance');

  return (
    <div className={`container container-lg  ${styles.featuresWrapper}`}>
      <ul className={`
        ${styles.list}
        ${appearances === 'default' && styles.defaultList}
        ${appearances ==='with-hover'&& styles.listWithHover}
        `}>
          {data.subSection.map(({ title, description, key } :any)=>(
            <li className={styles.item} key={key}>
              {title&&(
                <h3 className={styles.title}>{title}</h3>
              )}
              <TextBlock data = {description} />
              {/* <p className={styles.description}>{description}</p> */}
            </li>
          ))}
      </ul>
    </div>
  );
}
export default SectionGrid